<template>
    <div>
        <div class="input-group date" ref="container">
            <span class="input-group-addon"
                ><i class="fa fa-calendar"></i
            ></span>
            <input
                type="text"
                :name="name"
                class="form-control"
                :disabled="isDisabled"
                :readonly="isReadonly"
                :value="datepickerData"
            />
        </div>
    </div>
</template>
<script>

export default {
    data: function() {
        return {
            input: null,
            datepickerData: "",
            stopChangeTrigger: false
        };
    },
    props: {
        value: null,
        name: {
            default: ""
        },
        start_date: {
            type: String,
            default: ""
        },
        min_date: {
            type: String,
            default: ""
        },
        end_date: {
            type: String,
            default: ""
        },
        setDatepickerDate: {
            type: Boolean,
            default: false
        },
        initWithoutEmitEvent: {
            type: Boolean,
            default: false
        },
        orientation: null,
        disabled: false,
        options: {
            type: Object,
            default: () => {
                return {
                    startView: 0,
                    todayBtn: "linked",
                    keyboardNavigation: false,
                    forceParse: false,
                    autoclose: true,
                    format: "yyyy-mm-dd",
                    todayHighlight: true,
                    orientation: "top left",
                    enableOnReadonly: false
                };
            }
        }
    },
    computed: {
        isDisabled() {
            return this.$props.options.disabled || this.disabled;
        },
        isReadonly() {
            return this.$props.options.readonly;
        }
    },
    watch: {
        value(val) {
            this.datepickerData = val;
            if (this.stopChangeTrigger) {
                this.setValueWithoutChangeEvent(val);
            } else {
                this.setValue(val);
                this.$emit("change", val);
                this.$emit("input", val);
                this.$emit("changed");
            }
        },
        options: {
            deep: true,
            handler() {
                this.datepicker.datepicker("remove");
                this.initDatePicker();
                // $(this.$el)
                //     .find(".input-group.date").datepicker('remove')
            }
        }
    },
    methods: {
        setValue(value) {
            this.input.val(value).trigger("change");
        },
        setValueWithoutChangeEvent(value) {
            this.input.val(value);
        },
        setStopChangeTriggerFlag(value) {
            this.stopChangeTrigger = value;
        },
        initDatePicker() {
            this.input = $(this.$el).find("input");
            this.datepickerData = this.value;

            let language = $("html").attr("lang");
            let options = Object.assign(this.options, { language: language });
            if (this.start_date) options.startDate = this.start_date;
            if (this.min_date) options.minDate = this.min_date;
            if (this.end_date) options.endDate = this.end_date;
            if (this.orientation) options.orientation = this.orientation;
            this.datepicker = $(this.$el)
                .find(".input-group.date")
                .datepicker(options)
                .on("change", ev => {
                    this.$emit("change", this.input.val());
                    this.$emit("input", this.input.val());
                    this.datepickerData = this.input.val();
                });
            if (this.setDatepickerDate) {
                this.datepicker.datepicker("setDate", this.datepickerData);
            }
            if (this.initWithoutEmitEvent) {
                this.setValueWithoutChangeEvent(this.datepickerData);
            } else {
                this.setValue(this.datepickerData);
            }
        }
    },
    mounted() {
        this.initDatePicker();
    },
    beforeDestroy() {
        this.datepicker.datepicker("destroy");
    }
};
</script>
<style>
/*not scoped on purpose */
.datepicker-days {
    display: inline !important;
}
.prev:hover {
    cursor: pointer;
    background-color: #eeeeee;
}
.next:hover {
    cursor: pointer;
    background-color: #eeeeee;
}
.datepicker-switch:hover {
    cursor: pointer;
    background-color: #eeeeee;
}
.datepicker-dropdown.datepicker-orient-bottom:before,
.datepicker-dropdown.datepicker-orient-bottom:after,
.datepicker-dropdown.datepicker-orient-top:before,
.datepicker-dropdown.datepicker-orient-top:after {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}

.datepicker-dropdown.datepicker-orient-bottom:before,
.datepicker-dropdown.datepicker-orient-bottom:after {
    bottom: 100% !important;
}
.datepicker-dropdown.datepicker-orient-top:before,
.datepicker-dropdown.datepicker-orient-top:after {
    top: 100% !important;
}
</style>
